import { COLORS } from "../../constants";
import { globalVars } from "../../globalVariables";
import { settings } from "../../settings/settings";
import { getQT } from "../../utils/dom";
import { createTimer } from "../timers/createTimer";
export const buffsVisibleHTML = `<span>Buffs: <span style="color: ${COLORS.green};">visible</span> (Hide)</span>`;
export const buffsHiddenHTML = `<span>Buffs: <span style="color: ${COLORS.red};">hidden</span> (Show)</span>`;
export const createBuffsToggler = () => {
    const buffToggler = createTimer("buffToggler");
    buffToggler.style.cursor = "pointer";
    buffToggler.style.transition = "background-color 0.5s";
    buffToggler.onmouseenter = () => {
        buffToggler.style.backgroundColor = "rgba(90, 90, 90, 0.5)";
    };
    buffToggler.onmouseleave = () => {
        buffToggler.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
    };
    buffToggler.innerHTML = settings.showBuffTimers
        ? buffsVisibleHTML
        : buffsHiddenHTML;
    buffToggler.onclick = () => {
        settings.showBuffTimers = !settings.showBuffTimers;
        buffToggler.innerHTML = settings.showBuffTimers
            ? buffsVisibleHTML
            : buffsHiddenHTML;
        if (!settings.showBuffTimers) {
            globalVars.buffTimers.forEach((buff) => {
                getQT(buff.id)?.remove();
            });
        }
        else {
            globalVars.buffTimers.forEach((buff) => {
                createTimer(buff.id);
            });
        }
    };
};
